<template>
    <v-container>
        <v-divider id="divider" class="mt-4 mb-4"></v-divider>
    </v-container>
        <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
            <v-row>
                <v-col cols="12" md="3">
                </v-col>
                <v-col cols="12" md="6"  >
                    <v-container v-if="!tipoSeleccionado">
                        <v-row justify="center">
                            <v-col cols="12">
                                <h4 class="my-text-black text-center">¿Qué desea realizar?</h4>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                            <v-col cols="12" md="3" class="d-flex justify-center flex-grow-1" v-if="esBajaComplejidad()">
                                <!-- agregarConsulta() -->
                                <v-btn 
                                height="48"
                                @click="tipoSolicitud='consulta';tipoSeleccionado=true;"
                                id="boton-verde"
                                :loading="cargandoPracticas"
                                >
                                    Consulta
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-center flex-grow-1" v-if="esBajaComplejidad()">
                                <v-btn 
                                height="48"
                                @click="tipoSolicitud='practica';tipoSeleccionado=true;"
                                id="boton-verde"
                                :loading="cargandoPracticas"
                                >
                                    Práctica
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-center flex-grow-1" v-if="aceptaPracticaPesada() && esAltaComplejidad()">
                                <v-btn
                                height="48"
                                @click="tipoSolicitud='practica-pesada';tipoSeleccionado=true;"
                                id="boton-verde"
                                :loading="cargandoPracticas"
                                >
                                    Alta<br>complejidad
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-center flex-grow-1" v-if="(aceptaBonoAdicional() && !esACEAPP() && !esIOMA()) || (esACEAPP() && esBonoAdicional())">
                                <v-btn 
                                height="48"
                                @click="tipoSolicitud='bono-adicional';tipoSeleccionado=true;"
                                id="boton-verde"
                                :loading="cargandoPracticas"
                                >
                                    Bono<br>adicional
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" v-if="cargandoPracticas">
                            <v-col cols="12" md="auto">
                                <h4 class="my-text-black">Cargando prácticas</h4>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
                <v-col cols="12" md="3">
                </v-col>
            </v-row>
            <div v-if="tipoSeleccionado">
                <v-row justify="center" align="center">
                    <v-col cols="12" md="auto">
                        <h3 class="my-text-black">Cargando {{ tipoSolicitud.split('-').map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1)).join(' ')}}</h3>
                    </v-col>
                </v-row>
                <v-divider id="divider"></v-divider>
                <BonoAdicionalForm 
                    v-if="tipoSolicitud == 'bono-adicional' || tipoSolicitud == 'practica-pesada'"
                    @cerrar-bono-adicional="tipoSeleccionado=false"
                    :tipoSolicitud="tipoSolicitud"
                ></BonoAdicionalForm>
                <v-container v-if="tipoSolicitud != 'bono-adicional' && tipoSolicitud != 'practica-pesada'">
                    <div v-if="nroAutorizacionUnico()">
                        <v-row>
                            <v-col cols="12">
                                <v-label class="my-text-black mt-4">Número de autorización</v-label>
                                <v-text-field
                                    v-model="solicitud.NroAutorizacion"
                                    label="Número de autorización"
                                    justify-end
                                    outlined
                                    variant="solo"
                                    clearable
                                    required
                                    :rules="aceptaNroAutorizacionCero() ? obligatorioAlfanumerico : obligatorioAlfanumericoSinCero"
                                    class="asterisco"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-if="tipoSolicitud == 'practica'">
                        <v-row>
                            <v-col cols="12" md="3">
                                <h4 class="my-text-black">Datos del profesional prescriptor</h4>
                            </v-col>
                            <v-col cols="12" md="8">
                                <p text-h5 class="font-weight-light">Ingrese nombre y matrícula</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    required
                                    class="asterisco"
                                    clearable 
                                    :rules="obligatorioNumerico"
                                    label="Matricula" 
                                    variant="solo"
                                    v-model="solicitud.MatriculaPrescriptor"
                                    @update:modelValue="actualizarProfesionalPrescriptor"
                                >                                
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select
                                    v-model="tipoMatriculaSeleccionada"
                                    :items="tiposDeMatriculas"
                                    label="Tipo matrícula"
                                    variant="solo"
                                    required
                                    :rules="obligatorio"
                                    class="asterisco"
                                    clearable
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-select                                    
                            v-model="profesionSeleccionada"
                            :items="profesiones"
                            label="Profesión"
                            variant="solo"
                            item-title="descripcion"
                            return-object
                            required
                            :loading="cargandoProfesiones"
                            :rules="obligatorio"
                            class="asterisco"
                            clearable
                        ></v-select>                           
                        <v-text-field
                            required
                            class="asterisco"
                            clearable 
                            :rules="obligatorioAlfabetico"
                            label="Apellido y nombre" 
                            variant="solo"
                            v-model="solicitud.NombreApellidoPrescriptor"
                        >
                        </v-text-field>
                        <v-divider id="divider"></v-divider>
                    </div>
                    <div>
                        <v-row>
                            <v-col cols="12" md="3">
                                <h4 class="my-text-black">Datos del profesional efector</h4>
                            </v-col>
                            <v-col cols="12" md="8">
                                <p text-h5 class="font-weight-light">Busque por nombre o matrícula</p>
                            </v-col>
                        </v-row>
                        <v-autocomplete
                            required
                            class="asterisco"
                            :rules="obligatorio"
                            label="Matricula - Apellido y Nombre"
                            :items="profesionalesFacturador"
                            return-object
                            :item-title="itemTitlePrescriptor" 
                            variant="solo"
                            v-model="profesionalEfector"
                            auto-select-first="true"
                            no-data-text="No se encontraron resultados"
                            :menu-props="{width: 200}"
                            @update:modelValue="onProfesionalChange"
                            :loading="cargandoEfector"
                        ></v-autocomplete>
                        <EspecialidadOptions
                            ref="especialidadOptions"
                            :obligatorio="obligatorio"
                            :idProfesional="profesionalEfector ? profesionalEfector.id : null"
                            @especialidadSeleccionada="onEspecialidadChange($event)"
                        ></EspecialidadOptions>

                        <v-divider id="divider"></v-divider>
                        <v-row>
                            <v-col cols="12">
                                <v-label class="my-text-black mt-4">Cargue un archivo de ser necesario</v-label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" class="mb-4">
                                <ModalArchivosConTipo
                                    @agregarArchivos="agregarArchivos"
                                    :tiposDocumentacion="tiposDocumentacion"
                                ></ModalArchivosConTipo>
                            </v-col>
                            <v-col cols="12" md="12">
                                <!-- <v-chip-group>
                                    <v-chip v-for="file in solicitud.Files" :key="file.nombre">{{this.tipoDocumentacion(file.tipoDocumentacion) +''+ file.nombre }}</v-chip>
                                </v-chip-group> -->
                                <ImageTable
                                    v-if="this.solicitud.Files && this.solicitud.Files.length > 0"
                                    :files="this.solicitud.Files"
                                    :headers="[
                                        { title: 'Documentación', key: 'tipoDocumentacion'},
                                        { title: 'Nombre', key: 'nombre' },
                                        { title: 'Tipo', key: 'tipoMime' },
                                        { title: 'Acciones', key: 'contenidoBase64' }
                                    ]"
                                    :tiposDocumentacion="tiposDocumentacion"
                                    :mostrarEliminar="true"
                                    :mostrarNewTab="false"
                                    :mostrarDownload="false"
                                    @eliminar-archivo="eliminarArchivo"
                                >  
                                </ImageTable>
                            </v-col>
                        </v-row>
                        <v-divider id="divider"></v-divider>
                    </div>
                    <div v-if="tipoSolicitud == 'practica'">
                        <label class="my-text-black mt-4">Gasto asignado al:</label>
                        <v-radio-group
                        v-model="solicitud.Gastos"
                        inline
                        >
                        <v-radio
                            label="Prestador"
                            value="prestador"
                            checked
                        ></v-radio>
                        <v-radio
                            label="Profesional"
                            value="profesional"
                        ></v-radio>
                        </v-radio-group>
                    </div>
                    <div v-if="profSeleccionado">
                        <v-label class="my-text-black">Añada las prestaciones que desea solicitar</v-label>
                        <v-row align="center">
                            <v-col cols="12" md="8">
                                <v-autocomplete
                                    v-model="prestacion"
                                    :items="filteredPrestaciones"
                                    label="Selecciona una prestacion"
                                    :item-title="itemTitlePrestacion"
                                    return-object
                                    variant="solo"
                                    placeholder="Busque práctica por código o descripción"
                                    auto-select-first="true"
                                    no-data-text="No se encontraron resultados"
                                    :menu-props="{width: 200}"
                                    class="asterisco"
                                    :loading="cargandoPracticas"
                                    >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field 
                                    label="Cantidad" 
                                    variant="solo"
                                    v-model="prestacionASolicitar.Cantidad"
                                    type="number"
                                    :rules="opcionalNumerico"
                                    class="asterisco"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="d-flex align-center">
                                <v-btn 
                                @click="agregarPrestacion" 
                                block 
                                class="py-7 mb-5" 
                                id="boton-verde" 
                                :disabled="(tipoSolicitud=='practica' && cantSolicitudes == cantPracticasPorOrden())||(tipoSolicitud=='consulta' && cantSolicitudes == 1)"
                                :loading="agregandoPractica"
                                >
                                    Añadir
                                </v-btn>
                            </v-col>
                        </v-row>
                        <ItemPrestacion 
                        @eliminar-prestacion="eliminarPrestacion"
                        :listadoPrestaciones="filteredSolicitudes"
                        :diagnosticos="diagnosticos"
                        :obligatorio="obligatorio"
                        :mostrarDiagnostico="tipoSolicitud == 'practica'"
                        :mostrarCargaArchivos="false"
                        :tiposDocumentacion="tiposDocumentacion"
                        :nroAutorizacionPorPrestacion="this.nroAutorizacionPorPrestacion()"
                        :aceptaNroAutorizacionCero="this.aceptaNroAutorizacionCero()"
                        @actualizar-copago-solicitud="actualizarCopagoSolicitud"
                        ></ItemPrestacion>

                        <v-label class="my-text-black mt-4" v-if="!practicasParaConsulta">Copago total</v-label>
                        <v-text-field
                            v-if="!practicasParaConsulta"
                            readonly
                            v-model="solicitud.Copago"
                            variant="solo"
                            prepend-inner-icon="mdi mdi-currency-usd"
                        >
                        </v-text-field>
                    </div>
                </v-container>
                <v-container>
                    <v-btn
                        block
                        class="mt-4"
                        v-if="tipoSeleccionado"
                        @click="tipoSeleccionado=false;reiniciarEstado();"
                        id="boton-rojo"
                        :loading="cargando == true"
                        :disabled="cargando == true"
                        >
                            Cancelar carga de {{ tipoSolicitud.split('-').map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1)).join(' ')}}
                    </v-btn>
                </v-container>
                <v-container v-if="tipoSolicitud != 'bono-adicional' && tipoSolicitud != 'practica-pesada'">
                    <v-container v-if="practicasParaConsulta">
                        <v-row justify="center" align="center">
                            <v-col cols="12" md="auto">
                                <h3 class="my-text-black">Usted va a cargar prácticas para esta consulta</h3>
                            </v-col>
                        </v-row>
                        <v-divider id="divider"></v-divider>
                        <div v-if="profSeleccionado">
                            <v-label class="my-text-black">Añada las prestaciones que desea solicitar</v-label>
                            <v-row align="center">
                                <v-col cols="12" md="8">
                                    <v-autocomplete
                                        v-model="prestacion2"
                                        :items="filteredPracticas"
                                        label="Busque práctica por código o descripción"
                                        :item-title="itemTitlePrestacion"
                                        return-object
                                        variant="solo"
                                        placeholder="Seleccione una practica"
                                        auto-select-first="true"
                                        no-data-text="No se encontraron resultados"
                                        :menu-props="{width: 200}"
                                        class="asterisco"
                                        :loading="cargandoPracticas"
                                        >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field 
                                        label="Cantidad" 
                                        variant="solo"
                                        v-model="prestacionASolicitar.Cantidad"
                                        type="number"
                                        :rules="opcionalNumerico"
                                        class="asterisco"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="2" class="d-flex align-center">
                                    <v-btn 
                                    @click="agregarPracticaParaConsulta"
                                    block 
                                    class="py-7 mb-5" 
                                    id="boton-verde" 
                                    :disabled="(cantConsultas == cantPracticasPorOrden() - 1)"
                                    :loading="agregandoPracticaConsulta"
                                    >
                                        Añadir
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <ItemPrestacion
                            @eliminar-prestacion="eliminarPracticaParaConsulta"
                            :listadoPrestaciones="prestacionesASolicitar.filter(p => p.Codigo != '420101')"
                            :diagnosticos="diagnosticos"
                            :obligatorio="obligatorio"
                            :mostrarDiagnostico="true"
                            :mostrarCargaArchivos="false"
                            :tiposDocumentacion="tiposDocumentacion"
                            :nroAutorizacionPorPrestacion="this.nroAutorizacionPorPrestacion()"
                            :aceptaNroAutorizacionCero="this.aceptaNroAutorizacionCero()"
                            @actualizar-copago-solicitud="actualizarCopagoSolicitud"
                            ></ItemPrestacion>
                            <v-label class="my-text-black mt-4">Copago total</v-label>
                            <v-text-field
                                readonly
                                v-model="solicitud.Copago"
                                variant="solo"
                                prepend-inner-icon="mdi mdi-currency-usd"
                            >
                            </v-text-field>
                        </div>
                        <div>
                            <v-row>
                                <v-col cols="12" md="3">
                                    <h4 class="my-text-black">Datos del profesional prescriptor</h4>
                                </v-col>
                                <v-col cols="12" md="8">
                                    <p text-h5 class="font-weight-light">Ingrese nombre y matrícula</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        required
                                        class="asterisco"
                                        clearable 
                                        :rules="obligatorioNumerico"
                                        label="Matricula" 
                                        variant="solo"
                                        v-model="solicitud.MatriculaPrescriptor"
                                        @update:modelValue="actualizarProfesionalPrescriptor"
                                    >                                
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-select
                                        v-model="tipoMatriculaSeleccionada"
                                        :items="tiposDeMatriculas"
                                        label="Tipo matrícula"
                                        variant="solo"
                                        required
                                        :rules="obligatorio"
                                        class="asterisco"
                                        clearable
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-select                                    
                                v-model="profesionSeleccionada"
                                :items="profesiones"
                                label="Profesión"
                                variant="solo"
                                item-title="descripcion"
                                return-object
                                required
                                :loading="cargandoProfesiones"
                                :rules="obligatorio"
                                class="asterisco"
                                clearable
                            ></v-select>                           
                            <v-text-field
                                required
                                class="asterisco"
                                clearable 
                                :rules="obligatorioAlfabetico"
                                label="Apellido y nombre" 
                                variant="solo"
                                v-model="solicitud.NombreApellidoPrescriptor"
                            >
                            </v-text-field>
                            <v-divider id="divider"></v-divider>
                        </div>
                        <v-btn
                            block
                            v-if="practicasParaConsulta"
                            :loading="cargando == true"
                            :disabled="cargando == true"
                            @click="practicasParaConsulta=false; cantConsultas = 0"
                            id="boton-rojo"
                            class="mt-4"
                            >
                                Cancelar carga de prácticas para consulta
                        </v-btn>
                    </v-container>
                    <v-container class="d-flex justify-center align-center">
                        <Loader v-if="cargando"></Loader>
                    </v-container>
                    <div>
                        <v-row>
                            <v-col v-if="tipoSolicitud == 'consulta' && !practicasParaConsulta && tipoSeleccionado && (this.cantPracticasPorOrden() - 1) > 0">
                                <v-btn class="mt-4" id="boton-verde" block @click="practicasParaConsulta = true" :loading="cargando == true" :disabled="cargando == true">Cargar prácticas a la consulta</v-btn>
                            </v-col>
                            <v-col>
                                <v-btn class="mt-4" id="boton-verde" type="submit" block :disabled="!valid || prestacionesASolicitar.length == 0 || cantSolicitudes ==0 || cargando == true" :loading="cargando == true" >Autorizar</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </div>
            </v-form>
        <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="cerrarModal"
        />
</template>

<style src="../assets/general.css">
</style>

<script>
/* eslint-disable */
    import ItemPrestacion from './ItemPrestacion.vue';
    import Prestacion from '@/interfaces/prestacionInterface';
    import PrestacionASolicitar from '@/interfaces/prestacionInterface'
    import PrestacionService from '@/api/PrestacionService';
    import AlertComponent from './AlertComponent.vue';
    import Solicitud from '@/interfaces/prestacionInterface';
    import Medico from '@/interfaces/medicoInterfaces';
    import FacturadorService from '@/api/FacturadorService';
    import ProfesionalService from '@/api/ProfesionalService';
    import Diagnostico from '@/interfaces/prestacionInterface';
    import DiagnosticoOptions from './DiagnosticoOptions.vue';
    import ImageInput from './ImageInput.vue';
    import EspecialidadOptions from './EspecialidadOptions.vue';
    import Loader from './Loader.vue';
    import ModalArchivosConTipo from './ModalArchivosConTipo.vue';
    import ImageModal from './ImageModal.vue';
    import GeneralService from '@/api/GeneralService';
    import { obligatorio, obligatorioNumerico, obligatorioAlfabetico, opcionalAlfaNumerico, opcionalNumerico, obligatorioNumericoSinCero, obligatorioAlfanumerico, obligatorioAlfanumericoSinCero} from '@/_helpers/rules';
    import BonoAdicionalForm from './BonoAdicionalForm.vue';
    import { polisTandil } from '@/_helpers/polisTandil';
    import ImageTable from './ImageTable.vue';

    const facturadorService = new FacturadorService();
    const generalService = new GeneralService();
    const prestacionService= new PrestacionService();
    const profesionalService = new ProfesionalService();

    export default {
        components:{
            ItemPrestacion,
            DiagnosticoOptions,
            AlertComponent,
            ImageInput,
            EspecialidadOptions,
            Loader,
            ModalArchivosConTipo,
            ImageModal,
            BonoAdicionalForm,
            ImageTable
        },
        data: () => ({
            obraSocial: '',
            tiposDocumentacion: [],
            valid: false,
            tipoSolicitud:'',
            tipoSeleccionado:false,
            solicitud: Solicitud = {Files: []},
            tipoMatriculaSeleccionada: null,
            tiposDeMatriculas: ['Matrícula Provincial', 'Matrícula Nacional'],
            tipoMatriculaParaEnviar: null,
            especialidadPrescriptor: null,
            profesionSeleccionada: null,
            profesiones: [],
            cargandoProfesiones: false,
            cantSolicitudes:0,
            cantConsultas:0,
            practicasParaConsulta : false,
            cargandoTipos: false,
            profSeleccionado: false,
            //datos para prestaciones
            codigo:'',
            codigo2:'',
            prestacion: Prestacion = { descripcion: ''},
            prestacion2: Prestacion = { descripcion: ''},
            prestacionASolicitar: PrestacionASolicitar = {},
            prestaciones:[],
            prestacionesFiltradas:[],
            prestacionesASolicitar:[],
            profesionalFacturador: Medico = {},
            profesionalEfector: Medico = null,
            profesionalPrescriptor: Medico = null,
            profesionalesFacturador:[],
            //datos para el diagnostico
            diagnosticos:Diagnostico = [],
            diagnostico:Diagnostico = null,
            //datos para mostrar errores
            showAlert:false,
            alertTitle: 'Error',
            alertText: 'Credenciales inválidas.',
            alertType: 'error',
            cargando: false,
            cargandoPracticas: false,
            cargandoEfector: false,
            agregandoPractica: false,
            agregandoPracticaConsulta: false,
            //reglas de formulario
            obligatorio: obligatorio,
            obligatorioAlfabetico: obligatorioAlfabetico,
            opcionalAlfaNumerico: opcionalAlfaNumerico,
            obligatorioAlfanumerico: obligatorioAlfanumerico,
            obligatorioAlfanumericoSinCero: obligatorioAlfanumericoSinCero,
            opcionalNumerico: opcionalNumerico,
            obligatorioNumerico: obligatorioNumerico,
            obligatorioNumericoSinCero: obligatorioNumericoSinCero,
            configuraciones: null,
        }),
        computed: {
            actualizarProfesionalPrescriptor(){
                if(this.solicitud.MatriculaPrescriptor){
                    this.profesionalPrescriptor = this.profesionalesFacturador.find(p => p.matriculaProvincial == this.solicitud.MatriculaPrescriptor);
                    if(this.profesionalPrescriptor){
                        this.solicitud.NombreApellidoPrescriptor = this.profesionalPrescriptor.apellidos + ' ' + this.profesionalPrescriptor.nombres;
                        this.tipoMatriculaSeleccionada = this.tiposDeMatriculas[0];
                    }
                    else{
                        this.profesionalPrescriptor = this.profesionalesFacturador.find(p => p.matriculaNacional == this.solicitud.MatriculaPrescriptor);
                        if(this.profesionalPrescriptor){
                            this.solicitud.NombreApellidoPrescriptor = this.profesionalPrescriptor.apellidos + ' ' + this.profesionalPrescriptor.nombres;
                            this.tipoMatriculaSeleccionada = this.tiposDeMatriculas[1];
                        }
                        else{
                            this.solicitud.NombreApellidoPrescriptor = null;
                            this.profesionSeleccionada = null;
                            this.tipoMatriculaSeleccionada = null;
                        }
                    }
                }
            },
            filteredPrestaciones() {
                let filtradas = [];
                if(this.tipoSolicitud == 'practica'){
                    filtradas = this.prestaciones.filter((p) => p.codigo != "420101");
                } else {
                    filtradas = this.prestaciones.filter((p) => p.codigo == "420101");
                }
                return filtradas.sort((a, b) => 
                    a.descripcion.trim().replace(/\s+/g, ' ').toLowerCase().localeCompare(
                        b.descripcion.trim().replace(/\s+/g, ' ').toLowerCase()
                    )                
                );
            },
            filteredPracticas() {
                let filtradas = this.prestaciones.filter((p) => p.codigo != '420101');
                return filtradas.sort((a, b) => 
                    a.descripcion.trim().replace(/\s+/g, ' ').toLowerCase().localeCompare(
                        b.descripcion.trim().replace(/\s+/g, ' ').toLowerCase()
                    )                
                );
            },
            filteredSolicitudes(){
                if(this.tipoSolicitud == 'practica'){
                    return this.prestacionesASolicitar.filter(p => p.Codigo != '420101');
                } else {
                    return this.prestacionesASolicitar.filter(p => p.Codigo == '420101');
                }
            },
            ordenarProfesionales(){
                return this.profesionalesFacturador.sort((a, b) => 
                    a.apellidos.toLocaleLowerCase().localeCompare(b.apellidos.toLocaleLowerCase())
                );
            }
        },
        async mounted() {
            this.solicitud.Gastos = 'prestador';
            this.cargarConfiguraciones();
            await this.cargarEfector();
            await this.getTiposDocumentacion();
            await this.cargarProfesiones();
            this.obraSocial = this.$store.getters.getObraSocial.nombre;
        },
        methods: {
            async handleSubmit() {
                if(this.valid && !this.cargando){
                    this.cargando = true;
                    this.armarSolicitud();
                    const response = await prestacionService.postSolicitud(this.solicitud);
                    let response2 = null;
                    if(response.status === 200){
                        response2 = await this.autorizarSolicitud(response.data.id);
                    }
                    await this.manejarRespuesta(response, response2);
                }
                this.cargando = false;
            },
            async cargarEfector(){
                this.cargandoEfector = true;
                this.profesionalFacturador = this.$store.getters.getProfesional;
                const profesionalesResponse = await facturadorService.getProfesionalesFacturador(this.$store.getters.getFacturador.id);
                if(profesionalesResponse.status == 200){
                    this.profesionalesFacturador = profesionalesResponse.data;
                }
                if(this.profesionalFacturador.matriculaProvincial != null){
                    this.profesionalEfector = this.profesionalFacturador;
                    this.solicitud.MatriculaEfector = this.profesionalFacturador.matriculaProvincial;
                    this.solicitud.NombreApellidoEfector = this.profesionalFacturador.apellidos + ' ' +this.profesionalFacturador.nombres;
                }
                else{
                    const profesionalLogeado = this.$store.getters.getProfesionalUsuario;
                    if(profesionalLogeado){
                        this.profesionalEfector = profesionalLogeado;
                        this.solicitud.MatriculaEfector = profesionalLogeado.matriculaProvincial;
                        this.solicitud.NombreApellidoEfector = profesionalLogeado.apellidos + ' ' +profesionalLogeado.nombres;
                    } else {
                        this.profesionalEfector = null;
                    }
                }
                this.cargandoEfector = false;
            },
            async cargarPracticas(){
                this.cargandoPracticas = true;
                const response = await prestacionService.getPracticas(this.$store.getters.getObraSocial.id, this.$store.getters.getIdProfesion);
                if(response.status == 200){
                    this.prestaciones = response.data;
                }
                this.cargandoPracticas = false;
            },
            async cargarProfesiones(){
                this.cargandoProfesiones = true;
                const response = await profesionalService.getProfesiones();
                if(response.status == 200){
                    this.profesiones = response.data;
                }
                this.cargandoProfesiones = false;
            },
            async getTiposDocumentacion(){
                this.cargandoTipos = true
                await generalService.GetTiposDocumentacion()
                    .then(response => {
                        this.tiposDocumentacion = response.data; //nombe, valor
                        this.tiposDocumentacion = this.tiposDocumentacion.filter(tipo => tipo.valor <= 2);
                    }) 
                    .catch(error => {
                        console.log(error);
                    });
                this.cargandoTipos = false;
            },
            actualizarCopagoSolicitud(){
                this.solicitud.Copago = this.prestacionesASolicitar.map(p => {
                    let copago = p.Copago ? parseFloat(p.Copago) : 0;
                    return copago*p.Cantidad;
                }).reduce((a, b) => a + b, 0);
            },
            async getCopagoPractica(idPractica){
                const obraSocialId = this.$store.getters.getObraSocial.id;
                const response = await prestacionService.getCopagoPractica(obraSocialId, idPractica);
                if(response && response.status == 200){
                    return response.data;
                }
                else{
                    return null;
                }
            },
            armarSolicitud(){
                this.solicitud.Prestaciones = this.prestacionesASolicitar.map(element => {
                    return {
                        Cantidad: element.Cantidad,
                        Codigo: element.Codigo,
                        IdDiagnostico: element.IdDiagnostico,
                        Files: element.Imagenes,
                        NroAutorizacion: element.NroAutorizacion,
                        Copago: element.Copago ? parseFloat(element.Copago): 0,
                    }
                });
                if (this.tipoMatriculaSeleccionada === 'Matrícula Provincial') {
                    this.tipoMatriculaParaEnviar = 'MP';
                } else {
                    this.tipoMatriculaParaEnviar = 'MN'; //hola
                }
                this.solicitud.TipoMatriculaPrescriptor = this.tipoMatriculaParaEnviar;
                this.solicitud.ProfesionPrescriptor = this.profesionSeleccionada?.idIOMA;
                this.solicitud.Username = this.$store.getters.getUsername;
                this.solicitud.IdFacturador = this.$store.getters.getFacturador.id;
                this.solicitud.ValidacionId = this.$store.getters.getPaciente.idValidacion;
                this.solicitud.EfectorId = this.profesionalEfector.id;
                // Si no existe consulta (420101) o si existe consulta con 1 > prácticas: enviar matricula y nombre del prescriptor en la solicitud
                const existeConsulta = Array.isArray(this.solicitud?.Prestaciones) &&
                this.solicitud.Prestaciones.some(p => p.Codigo === '420101');
                if (!existeConsulta || this.cantSolicitudes > 0) {
                    this.solicitud.MatriculaPrescriptor = this.solicitud.MatriculaPrescriptor;
                    this.solicitud.NombreApellidoPrescriptor = this.solicitud.NombreApellidoPrescriptor;
                } else {
                    // Si existe solo consulta, limpiar matricula y nombre del prescriptor en la solicitud
                    this.solicitud.MatriculaPrescriptor = null;
                    this.solicitud.NombreApellidoPrescriptor = null;
                }
                this.solicitud.TipoIngreso = this.$store.getters.getIngreso.valor;
                this.solicitud.Copago = this.solicitud.Copago ? this.solicitud.Copago : 0;
            },
            onProfesionalChange(){
                if(this.profesionalEfector){
                    this.$refs.especialidadOptions.getEspecialidadesProfesional(this.profesionalEfector.id)
                }
            },
            itemTitlePrescriptor(item) {
                if (!item) return '';
                if(item.matriculaProvincial){
                    return `${item.matriculaProvincial} - ${item.apellidos} ${item.nombres}`;
                }
                else{
                    return `${item.matriculaNacional} - ${item.apellidos} ${item.nombres}`;
                }
            },
            itemTitlePrestacion(item) {
                if (!item) return '';
                if(item.codigo == undefined){
                    return '';
                }
                if(item.codigo != item.codigoTraducido){
                    return `${item.codigo} - ${item.descripcion} - (${item.codigoTraducido} para ${this.obraSocial})`;
                }
                return `${item.codigo} - ${item.descripcion}`;
            },
            itemTitleDiagnostico(item) {
                if (!item) return '';
                return `${item.codigo} - ${item.descripcion}`;
            },
            validarPrestacion(){
                if(!this.prestacion){
                    return false;
                }
                return (this.prestacion.descripcion !== "" && (this.prestacionASolicitar.Cantidad > 0));
            },
            validarPracticaParaConsulta(){
                if(!this.prestacion2){
                    return false;
                }
                return (this.prestacion2.descripcion !== "" && (this.prestacionASolicitar.Cantidad > 0));
            },
            prestacionInvalida(){
                this.alertText = "La prestacion es inválida, asegurese de que el codigo exista y de indicar una cantidad.";
                this.alertType = "info";
                this.showAlert = true;
            },
            practicaYaCargada(nuevaPrest){
                return this.prestacionesASolicitar.findIndex(p => p.Codigo == nuevaPrest.Codigo  && p.Descripcion.toUpperCase() === nuevaPrest.Descripcion.toUpperCase());
            },
            async agregarPrestacion(){
                this.agregandoPractica = true;
                if(!this.validarPrestacion()){
                    this.prestacionInvalida();
                    this.agregandoPractica = false;
                    return 
                }
                const nuevaCant = this.cantSolicitudes + parseInt(this.prestacionASolicitar.Cantidad, 10);
                if((this.tipoSolicitud ==='practica' && nuevaCant <= this.cantPracticasPorOrden()) || (this.tipoSolicitud ==='consulta' && nuevaCant == 1)){
                    let copago = await this.getCopagoPractica(this.prestacion.id);
                    let nuevaPrest = {
                        Descripcion: this.prestacion.descripcion,
                        Codigo: this.prestacion.codigo,
                        Cantidad: this.prestacionASolicitar.Cantidad,
                        Operacion: 'Quitar',
                        Imagenes:this.solicitud.Imagenes,
                        Copago: copago ? copago : 0,
                    }
                    if(this.tipoSolicitud === 'practica'){
                        nuevaPrest.IdDiagnostico= this.solicitud.IdDiagnostico;
                    }
                    let posExiste = -1;
                    posExiste = this.practicaYaCargada(nuevaPrest);
                    if(posExiste != -1){
                        this.prestacionesASolicitar[posExiste].Cantidad = (
                            parseInt(this.prestacionesASolicitar[posExiste].Cantidad, 10) + 
                            parseInt(nuevaPrest.Cantidad, 10)
                        ).toString();
                    } else{
                        this.prestacionesASolicitar.push(nuevaPrest);
                    }
                    this.actualizarCopagoSolicitud();
                    this.cantSolicitudes = nuevaCant;
                } else {
                    if(this.tipoSolicitud === 'practica'){
                        this.alertText = `No pueden cargarse más de ${this.cantPracticasPorOrden()} prácticas`;
                    }else{ 
                        this.alertText = "Sólo se puede cargar una consulta";
                    }
                    this.alertType = "info";
                    this.showAlert = true;
                }
                this.agregandoPractica = false;
            },
            async agregarPracticaParaConsulta(){
                this.agregandoPracticaConsulta = true;
                if(!this.validarPracticaParaConsulta()){
                    this.prestacionInvalida();
                    this.agregandoPracticaConsulta = false;
                    return 
                }
                const nuevaCant = this.cantConsultas + parseInt(this.prestacionASolicitar.Cantidad, 10);
                if(nuevaCant <= this.cantPracticasPorOrden() - 1){
                    let copago = await this.getCopagoPractica(this.prestacion2.id);
                    const nuevaPrest = {
                        Descripcion: this.prestacion2.descripcion,
                        Codigo: this.prestacion2.codigo,
                        Cantidad: this.prestacionASolicitar.Cantidad,
                        Operacion: 'Quitar',
                        Imagenes:this.solicitud.Imagenes,
                        IdDiagnostico: this.solicitud.IdDiagnostico,
                        Copago: copago,
                    }
                    let posExiste = -1;
                    posExiste = this.practicaYaCargada(nuevaPrest);
                    if(posExiste != -1){
                        this.prestacionesASolicitar[posExiste].Cantidad = (
                            parseInt(this.prestacionesASolicitar[posExiste].Cantidad, 10) + 
                            parseInt(nuevaPrest.Cantidad, 10)
                        ).toString();
                    } else{
                        this.prestacionesASolicitar.push(nuevaPrest);
                    }
                    this.actualizarCopagoSolicitud();
                    this.cantConsultas = nuevaCant;
                } else {
                    this.alertText = `No pueden cargarse más de ${this.cantPracticasPorOrden() - 1} prácticas en una consulta.`;
                    this.alertType = "info";
                    this.showAlert = true;
                }
                this.agregandoPracticaConsulta = false;
            },
            agregarConsulta(){
                if(this.prestaciones){
                    this.codigo="420101",
                    this.prestacion = this.prestaciones.find(p => p.codigo == "420101");
                    if(this.prestacion && !this.yaExiste(this.prestacion) && this.cantSolicitudes < 1){
                        this.prestacionASolicitar = {
                            Cantidad : 1,
                        }
                        this.agregarPrestacion();
                    }
                }
            },
            async reiniciarEstado(){
                this.prestacion={
                    descripcion:"",
                };
                this.codigo="";
                this.tipoMatriculaParaEnviar = null;
                this.tipoMatriculaSeleccionada = null;
                this.cantSolicitudes = 0;
                this.cantConsultas = 0;
                this.prestacionesASolicitar = [];
                this.profesionalPrescriptor = null;
                this.solicitud.IdDiagnostico = null;
                this.practicasParaConsulta = false;
                this.solicitud.Copago = null;
                this.tipoSeleccionado = false;
                this.solicitud.Prestaciones = [];
                this.solicitud.Files = [];
                this.solicitud.IdEspecialidad = null;
                this.solicitud.ProfesionPrescriptor = null;
                this.solicitud.MatriculaPrescriptor = null;
                this.solicitud.NombreApellidoPrescriptor = null;
                this.solicitud.Gastos = 'prestador';
                this.solicitud.NroAutorizacion = null;
                this.profSeleccionado = false;
                await this.cargarEfector();
            },
            eliminarPrestacion(codigoAEliminar){
                const prestacionEliminada = this.prestacionesASolicitar.find(p => p.Codigo == codigoAEliminar);
                if(prestacionEliminada){
                    this.prestacionesASolicitar = this.prestacionesASolicitar.filter(p => p.Codigo != codigoAEliminar);
                    this.cantSolicitudes -= parseInt(prestacionEliminada.Cantidad, 10);
                    this.actualizarCopagoSolicitud()
                }
            },
            eliminarPracticaParaConsulta(codigoAEliminar){
                const prestacionEliminada = this.prestacionesASolicitar.find(p => p.Codigo == codigoAEliminar);
                if(prestacionEliminada){
                    this.prestacionesASolicitar = this.prestacionesASolicitar.filter(p => p.Codigo != codigoAEliminar);
                    this.cantConsultas -= parseInt(prestacionEliminada.Cantidad, 10);
                }
            },
            cancelarOperatoria() {
                this.$router.push('elegibilidad');
            },
            yaExiste(prest){
                return this.prestacionesASolicitar.find(p => p.Codigo === prest.codigo);
            },
            async manejarRespuesta(responseCreada, responseAutorizada){
                if(responseCreada.status === 200){
                    await this.reiniciarEstado();
                    if(responseAutorizada && responseAutorizada.status === 200){
                        this.alertTitle= "Solicitud creada";
                        this.alertText= responseAutorizada.data.mensaje + "\nPodrá visualizarla en el listado de solicitudes";
                        this.alertType="success";
                        this.showAlert= true;
                    }
                    else{
                        this.alertTitle= "Solicitud creada pero no autorizada";
                        this.alertText= "Podrá visualizarla en el listado de solicitudes cargadas. "+ responseAutorizada.data.mensaje + ".";
                        this.alertType="info";
                        this.showAlert= true;
                    }
                } else {
                    this.alertTitle= "No pudo crearse la solicitud";
                    this.alertText= responseCreada.data;
                    this.alertType="error";
                    this.showAlert= true;
                }
            },
            esPorConfianza(){
                return this.$store.getters.getPedirDatosPaciente;
            },
            cerrarModal(){
                this.showAlert = false;
                if(this.alertType === 'success'){
                    if(this.esPorConfianza()){
                        this.$router.push('elegibilidad');
                    } else {
                        this.$router.push('detalles-paciente');
                    }
                }
            },
            async autorizarSolicitud(idSolicitud){
                return await prestacionService.autorizarSolicitud(idSolicitud, this.$store.getters.getUsername);
            },
            tipoDocumentacion(valor){
                const tipo = this.tiposDocumentacion.find(tipo => tipo.valor === valor);
                return tipo ? `${tipo.nombre}-` : "";
            },
            cargarConfiguraciones(){
                this.configuraciones = this.$store.getters.getConfiguracionesOS;
            },
            nroAutorizacionPorPrestacion(){
                return this.configuraciones && this.configuraciones.requiereNroAutorizacionManual && this.configuraciones.puedeAutorizarPorPrestacion;
            },
            nroAutorizacionUnico(){
                return this.configuraciones && this.configuraciones.requiereNroAutorizacionManual && !this.configuraciones.puedeAutorizarPorPrestacion;
            },
            aceptaNroAutorizacionCero(){
                return this.configuraciones && this.configuraciones.aceptaNroAutorizacionCero;
            },
            cantPracticasPorOrden(){
                return this.configuraciones && this.configuraciones.cantMaxPrestacionesPorOrden;
            },
            copagoObligatorio(){
                return this.configuraciones && this.configuraciones.ingresoCopagoObligatorio;
            },
            aceptaBonoAdicional(){
                return this.configuraciones && this.configuraciones.aceptaBonoAdicional;
            },
            aceptaPracticaPesada(){
                return this.configuraciones && this.configuraciones.aceptaPracticaPesada;
            },
            async onEspecialidadChange(especialidad){
                if(especialidad){
                    this.$store.commit('setIdProfesion', especialidad.idProfesion)
                    await this.cargarPracticas();
                    if(this.tipoSolicitud == 'consulta'){
                        this.agregarConsulta();
                    }
                    this.profSeleccionado = true;
                    this.solicitud.IdEspecialidad = especialidad.id;
                }
                else{
                    this.profSeleccionado = false;
                    this.solicitud.IdEspecialidad = null;
                    this.$store.commit('setIdProfesion', null)
                }
            },
            //metodos para manejar archivos
            agregarArchivos(archivos){
                this.solicitud.Files.push(...archivos);
            },
            eliminarArchivo({dominio,idArchivo, idSolicitudPractica}) {
                this.solicitud.Files = this.solicitud.Files.filter(file => file.id !== idArchivo);
            },
            esIOMA(){
                return this.obraSocial === 'IOMA';
            },
            esACEAPP(){
                return this.obraSocial === 'ACEAPP';
            },
            esBajaComplejidad(){
                const tipoPrestacion = JSON.parse(localStorage.getItem('tipoPrestacion'));
                return (tipoPrestacion && tipoPrestacion?.valor === 'BAJA_COMPLEJIDAD');
            },
            esAltaComplejidad(){
                const tipoPrestacion = JSON.parse(localStorage.getItem('tipoPrestacion'));
                return (tipoPrestacion && tipoPrestacion?.valor === 'ALTA_COMPLEJIDAD');
            },
            esBonoAdicional(){
                const tipoPrestacion = JSON.parse(localStorage.getItem('tipoPrestacion'));
                return (tipoPrestacion && tipoPrestacion?.valor === 'BONO_ADICIONAL');
            }
        }
    }
</script>